import styled, { css } from 'styled-components';
import { breakpointMap, theme } from '../../../theme';
import { StyledContentCardProps } from './ContentCard';

const ContentCardUpperStylesSmall = css`
  padding: ${theme.spacings[3].rem} ${theme.spacings[3].rem} 0;
`;

const ContentCardUpperStylesLarge = css`
  padding: ${theme.spacings[3].rem} ${theme.spacings[4].rem} 0;
`;

const upperStyles = {
  small: ContentCardUpperStylesSmall,
  large: ContentCardUpperStylesLarge,
};

export const ContentCardUpper = styled.div<{
  cardSize: StyledContentCardProps['size'];
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ cardSize }) => breakpointMap(cardSize, (size) => upperStyles[size])}
`;
